import { Stack } from 'expo-router';
import { Platform, useWindowDimensions } from 'react-native';

import { getScreenTitleHeader } from '../../../components/get-screen-title-header';

const nativeMoreHeader = getScreenTitleHeader({ backStyle: 'none', showDivider: true });
const otherTermsHeader = getScreenTitleHeader({
  backStyle: 'back',
  cannotGoBackHref: '/account',
});
const mobileWebMoreHeader = getScreenTitleHeader({
  backStyle: 'close',
  cannotGoBackHref: '/',
  showDivider: true,
});

export default function MoreLayout() {
  const { width } = useWindowDimensions();
  const isDesktopWeb = Platform.OS === 'web' && width >= 768;

  return (
    <Stack
      screenOptions={{
        headerShown: !isDesktopWeb,
      }}
    >
      <Stack.Screen
        name="account/index"
        options={{
          title: 'More',
          header: Platform.OS === 'web' ? mobileWebMoreHeader : nativeMoreHeader,
        }}
      />
      <Stack.Screen
        name="account/other-terms"
        options={{ title: 'Other Terms & Policies', header: otherTermsHeader }}
      />
    </Stack>
  );
}
